import { Select } from 'antd';
import React from 'react';
import type { DocumentFilterCondition } from '../../types';

interface NoteSourceInputProps {
    condition: DocumentFilterCondition;
    groupId: string;
    updateCondition: (groupId: string, conditionId: string, updates: Partial<DocumentFilterCondition>) => void;
}

/**
 * Tag input for document IDs (note source values)
 */
export const NoteSourceInput: React.FC<NoteSourceInputProps> = ({ condition, groupId, updateCondition }) => {
    return (
        <Select
            mode="tags"
            placeholder="Enter document IDs..."
            className="w-full [&_.ant-select-selector]:!min-h-[32px]"
            allowClear
            value={condition.value}
            onChange={vals => updateCondition(groupId, condition.id, { value: vals?.length ? vals : undefined })}
        />
    );
};
